export default __webpack_public_path__ + "static/media/Marseille.e25c90b4.png";